import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ArrowRight } from "lucide-react";
import { ROOM_PAGES } from "../screens/shop/rooms/pages";

// The server already answers unknown URLs with a 404 status (serve.json +
// build/404.html); this is what the visitor sees. It used to be one red line
// with nowhere to go, so anyone arriving from an old link left. Point them at
// the pages people actually come for.

const PRODUCTS = [
	{ text: "Custom Roller Shades", to: "/shop/info/roller" },
	{ text: "Zebra Shades", to: "/shop/info/zebra" },
	{ text: "Honeycomb Cellular Shades", to: "/shop/info/cellular" },
	{ text: "Sheer Horizontal Shades", to: "/shop/info/sheer" },
	{ text: "Dream Shades", to: "/shop/info/dream-shades" },
];

const HELP = [
	{ text: "Free fabric samples", to: "/swatches" },
	{ text: "Measuring guide", to: "/guides/measuring-guide" },
	{ text: "Toronto showroom", to: "/blinds-toronto" },
	{ text: "Blog", to: "/blog" },
	{ text: "Contact us", to: "/contact" },
];

const listLink =
	"text-[17px] underline-offset-4 decoration-1 hover:underline";

const Column = ({ title, links }) => (
	<div>
		<h2 className="text-[11px] uppercase tracking-[0.18em] font-medium text-[#5E5E5A]">
			{title}
		</h2>
		<ul className="mt-4 space-y-3">
			{links.map((link) => (
				<li key={link.to}>
					<Link to={link.to} className={listLink}>
						{link.text}
					</Link>
				</li>
			))}
		</ul>
	</div>
);

const NotFound = () => {
	return (
		<div className="bg-[#FAFAF7] font-inter text-[#141414]">
			<Helmet>
				<title>Page Not Found | Off Cut Shades</title>
				<meta name="robots" content="noindex" />
			</Helmet>
			<div className="max-w-[1320px] mx-auto px-4 sm:px-8 lg:px-14 py-16 md:py-24">
				<p className="text-[13px] uppercase tracking-[0.14em] font-medium text-[#BE2026]">
					404
				</p>
				<h1 className="mt-4 font-instrument text-[48px] md:text-[72px] font-normal tracking-[-0.02em] leading-[0.95] max-w-3xl">
					This page has moved or no longer exists
				</h1>
				<p className="mt-6 text-lg text-[#3A3A37] max-w-2xl">
					The link may be old. Everything we make is still here: start
					with the shop, or pick up where you were going below.
				</p>
				<Link
					to="/shop"
					className="mt-8 inline-flex items-center gap-2 min-h-[48px] px-8 bg-[#141414] text-[#FAFAF7] text-[15px] font-medium hover:bg-[#2a2a2a] transition-colors"
				>
					Shop all shades
					<ArrowRight aria-hidden="true" className="w-4 h-4" />
				</Link>

				<div className="mt-16 pt-10 border-t border-[#E4E2DC] grid gap-10 sm:grid-cols-3">
					<Column title="Shades" links={PRODUCTS} />
					<Column
						title="By room"
						links={ROOM_PAGES.map((room) => ({
							text: `${room.label} Shades`,
							to: `/shades/${room.slug}`,
						}))}
					/>
					<Column title="Help" links={HELP} />
				</div>
			</div>
		</div>
	);
};

export default NotFound;
